import createAction from '../actions';

export const CONSULTATION_WILL_INIT = createAction('CONSULTATION_WILL_INIT');
export const CONSULTATION_DID_INIT = createAction('CONSULTATION_DID_INIT');

export const CONSULTATION_WILL_START = createAction('CONSULTATION_WILL_START');
export const CONSULTATION_DID_START = createAction('CONSULTATION_DID_START');

export const CONSULTATION_WILL_STOP = createAction('CONSULTATION_WILL_STOP');
export const CONSULTATION_DID_STOP = createAction('CONSULTATION_DID_STOP');

export const REMOTE_CLIENT_WILL_JOIN = createAction('REMOTE_CLIENT_WILL_JOIN');
export const REMOTE_CLIENT_DID_JOIN = createAction('REMOTE_CLIENT_DID_JOIN');

export const REMOTE_CLIENT_DID_LEAVE = createAction('REMOTE_CLIENT_DID_LEAVE');
